module.exports = __webpack_public_path__ + "img/首页新闻资讯图片.0588b71e.png";